<div class="sub-header">
    <div class="title">{{ 'SHARED.ROUTE.ACQUIRE.WIZARD.SELECTROUTE.TITLE' | translate}}</div>
    <div class="help-text">{{ 'SHARED.ROUTE.ACQUIRE.WIZARD.SELECTROUTE.HELP' | translate}}</div>
    <div class="search-pair">
        <input type="text" class="searchbox extralarge" placeholder="{{ 'SEARCH' | translate }}"
            (ngModelChange)="this.searchTextUpdate.next($event)" [(ngModel)]="searchText" />
        <div class="searchbox-contadors">{{ getSelectedRoutesCount() }}</div>
        <actions [actionstrip]="actions" (clickAction)="onClickAction($event)">
        </actions>
    </div>
    <div *ngIf="wizard.exceededMaximumNumberOfRoutesToAcquireJoints" class="banner-acquire">
        <div class="icona"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <div class="texte"
            [innerHTML]="'SHARED.ROUTE.ACQUIRE.WIZARD.MAXIMUMNUMBEROFROUTESTOACQUIREJOINTS'| translate:{maxRoutes:wizard.maximumNumberOfRoutesToAcquireJoints, numSelectRoutes:getSelectedRoutesCount()}">
        </div>
    </div>
</div>

<div class="list">
    <shared-route-acquire-route-item *ngFor="let item of getRoutes() | slice:0:sliceCount; let i=index" [route]="item"
        (click)="onSelectRoute(item)" class="item partnerItem monochrome reduced"
        [ngClass]="{'selected':isSelected(item.routeId)}">
    </shared-route-acquire-route-item>

    <div class="explanation noitems help-text" *ngIf="isEmpty()">
        {{'SHARED.ROUTE.ACQUIRE.WIZARD.ISEMPTY'| translate}}
    </div>

    <div class="hiddenRoutes" *ngIf="hiddenRoutesMessage && hiddenRoutesMessage!=''"
        [innerHTML]="hiddenRoutesMessage | safe:'html'">
    </div>
</div>